import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
function DetailArrArea(props: any) {
  let myProps = {
    Style: {},
    study_sort_det_arr: [],
    word_pre_info: null,
    ...props
  };
  let Style = myProps.Style;
  let study_sort_det_arr = myProps.study_sort_det_arr;
  let word_pre_info = myProps.word_pre_info;
  let group_stu_det_arr: any = [];
  if (word_pre_info && word_pre_info.group_stu_det_arr) {
    group_stu_det_arr = word_pre_info.group_stu_det_arr;
  }
  var now_y=DateFunc.get_date_format(new Date(),"Y");
  const get_det_tags = () => {
    let det_tags = study_sort_det_arr.map((item: any, idx: number) => {
      let row_group_det: any = {};
      for (let det_i = 0; det_i < group_stu_det_arr.length; det_i++) {
        if (group_stu_det_arr[det_i].a_cont_part == item.cont_part
          && group_stu_det_arr[det_i].a_cont_sort_det == item.value
        ) {
          row_group_det = group_stu_det_arr[det_i];
        }
      }
      let time_str = "";
      let last_time_str = "";
      if (row_group_det && row_group_det.a_elapse_time_sec_tot) {
        let row_time_json:any = strFunc.secondsToTimeJson(row_group_det.a_elapse_time_sec_tot);
        time_str = row_time_json.i + ":" + row_time_json.s;
        if (row_time_json.h!="00") {
          time_str = row_time_json.h + ":" + time_str;
        }
      }
      if (row_group_det && row_group_det.a_elapse_time_sec) {
        let row_time_json:any = strFunc.secondsToTimeJson(row_group_det.a_elapse_time_sec);
        last_time_str = row_time_json.i + ":" + row_time_json.s;
        if (row_time_json.h!="00") {
          last_time_str = row_time_json.h + ":" + time_str;
        }
      }
      let percent_str = "";
      let cnt_str="";
      if(row_group_det&&row_group_det.a_matter_cnt&&row_group_det.a_correct_cnt){
        cnt_str=row_group_det.a_correct_cnt+"/"+row_group_det.a_matter_cnt;
        row_group_det.a_matter_cnt=strFunc.uncomma_int(row_group_det.a_matter_cnt);
        row_group_det.a_correct_cnt=strFunc.uncomma_int(row_group_det.a_correct_cnt);
        let percent=(row_group_det.a_correct_cnt/row_group_det.a_matter_cnt)*100;
        percent_str=percent.toFixed(1);
      }
      let last_date_str="";
      if(row_group_det&&row_group_det.a_restart_date){
        last_date_str=row_group_det.a_restart_date.substring(0,10);
        if(last_date_str.substring(0,4)==now_y){
          last_date_str=last_date_str.substring(5);
        }
      }

      return (
        <tr key={idx} >
          <td>{item.text}</td>
          <td>
            {time_str}
          </td>
          <td>{last_time_str}</td>
          <td>{percent_str}</td>
          <td>{cnt_str}</td>
        </tr>
      );
    });

    return det_tags;
  };


  return (
    <>
      {get_det_tags()}
    </>
  );
};
export default DetailArrArea;